module.exports = __webpack_public_path__ + "img/MatrixExch-logo_w.dca98ba.png";